import recurrenceMasterSelectors from './recurrenceMasterSelectors';
import bookForSelectors from './bookForSelectors';
import attendeesSelectors from './attendeesSelectors';

export default {
  ...recurrenceMasterSelectors,
  ...bookForSelectors,
  ...attendeesSelectors
};
